import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BazisInputFileComponent } from '@bazis/form/components/base/inputs/input-file.component';

@Component({
    selector: 'app-input-file',
    templateUrl: './input-file.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppInputFileComponent extends BazisInputFileComponent {
    searchControl = new FormControl();
}
